import { put, select, takeEvery } from "redux-saga/effects";
import { API } from "../../services";
import type { LogEntry } from "../types";
import { getIsAuthenticated } from "../../user/selectors";

function* fetchLogEntries(action) {
  try {
    const isAuthenticated = yield select(getIsAuthenticated);
    if (!isAuthenticated) {
      yield put({
        type: "LOAD_LOG_FAILED",
        message: "Not Authenticated",
      });
      return;
    }
    let entries: LogEntry<any>[] | null | undefined = null;
    const result = yield API.get("rugged-brain-api", "/habit-entries", null);
    entries = result.map((entry) => {
      return { ...entry, time: entry.timeMs };
    });

    yield put({
      type: "LOAD_LOG_SUCCEEDED",
      entries: entries,
    });
  } catch (e) {
    console.error(e);
    yield put({
      type: "LOAD_LOG_FAILED",
      message: e.message,
    });
  }
}

function* updateLogEntries(action) {
  try {
    const isAuthenticated = yield select(getIsAuthenticated);

    if (!isAuthenticated) {
      yield put({
        type: "STORE_LOG_FAILED",
        message: "Not Authenticated",
      });
      return;
    }
    yield API.post("rugged-brain-api", "/habit-entries", {
      body: action.logentry,
    });

    yield put({
      type: "STORE_LOG_SUCCEEDED",
    });
  } catch (e) {
    console.error(e);
    yield put({
      type: "STORE_LOG_FAILED",
      message: e.message,
    });
  }
}

function* logSaga() {
  yield takeEvery("LOAD_LOG", fetchLogEntries);
  yield takeEvery("ADD_LOG", updateLogEntries);
}

export default logSaga;
